import { Component, OnInit, Input } from '@angular/core';
import { MessageContent } from 'src/app/messages/interfaces/MessageContent';

@Component({
  selector: 'app-view-message-content',
  templateUrl: './view-message-content.component.html',
  styleUrls: ['./view-message-content.component.scss']
})
export class ViewMessageContentComponent implements OnInit {

  @Input() messageContent: MessageContent;

  constructor() { }

  ngOnInit(): void {
  }

}
